module.exports = __webpack_public_path__ + "static/media/YE.20c6e27f.svg";